import { render, staticRenderFns } from "./KeyFeedbackCard.vue?vue&type=template&id=0f8d4f88&scoped=true"
import script from "./KeyFeedbackCard.vue?vue&type=script&lang=js"
export * from "./KeyFeedbackCard.vue?vue&type=script&lang=js"
import style0 from "./KeyFeedbackCard.vue?vue&type=style&index=0&id=0f8d4f88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8d4f88",
  null
  
)

export default component.exports